var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSatisfactionSurvey = function SvgSatisfactionSurvey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "satisfaction_survey_svg2__a",
    x1: 222.9,
    x2: 33.1,
    y1: -36.4,
    y2: 178.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#satisfaction_survey_svg2__a",
    id: "satisfaction_survey_svg2__b",
    x1: 178.2,
    x2: -11.6,
    y1: -75.8,
    y2: 139.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#satisfaction_survey_svg2__a",
    id: "satisfaction_survey_svg2__c",
    x1: 242.7,
    x2: 52.9,
    y1: -18.9,
    y2: 196.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#satisfaction_survey_svg2__a",
    id: "satisfaction_survey_svg2__d",
    x1: 276.5,
    x2: 86.7,
    y1: 10.9,
    y2: 226.2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#satisfaction_survey_svg2__a",
    id: "satisfaction_survey_svg2__e",
    x1: 186.9,
    x2: -2.9,
    y1: -68.1,
    y2: 147.3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#satisfaction_survey_svg2__a",
    id: "satisfaction_survey_svg2__f",
    x1: 179.2,
    x2: -10.6,
    y1: -74.9,
    y2: 140.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#satisfaction_survey_svg2__a",
    id: "satisfaction_survey_svg2__g",
    x1: 192.3,
    x2: 2.5,
    y1: -63.3,
    y2: 152
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#satisfaction_survey_svg2__a",
    id: "satisfaction_survey_svg2__h",
    x1: 191.3,
    x2: 1.4,
    y1: -64.3,
    y2: 151.1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#satisfaction_survey_svg2__a",
    id: "satisfaction_survey_svg2__i",
    x1: 212.5,
    x2: 22.7,
    y1: -45.5,
    y2: 169.8
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#satisfaction_survey_svg2__a",
    id: "satisfaction_survey_svg2__j",
    x1: 218.4,
    x2: 28.5,
    y1: -40.4,
    y2: 175
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#satisfaction_survey_svg2__a",
    id: "satisfaction_survey_svg2__k",
    x1: 212.1,
    x2: 22.3,
    y1: -45.9,
    y2: 169.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#satisfaction_survey_svg2__a",
    id: "satisfaction_survey_svg2__l",
    x1: 211,
    x2: 21.2,
    y1: -46.9,
    y2: 168.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#satisfaction_survey_svg2__a",
    id: "satisfaction_survey_svg2__m",
    x1: 232.3,
    x2: 42.5,
    y1: -28.1,
    y2: 187.3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#satisfaction_survey_svg2__a",
    id: "satisfaction_survey_svg2__n",
    x1: 233.2,
    x2: 43.4,
    y1: -27.3,
    y2: 188
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#satisfaction_survey_svg2__a",
    id: "satisfaction_survey_svg2__o",
    x1: 231.9,
    x2: 42.1,
    y1: -28.5,
    y2: 186.9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#satisfaction_survey_svg2__a",
    id: "satisfaction_survey_svg2__p",
    x1: 230.8,
    x2: 41,
    y1: -29.4,
    y2: 185.9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#satisfaction_survey_svg2__a",
    id: "satisfaction_survey_svg2__q",
    x1: 252.1,
    x2: 62.3,
    y1: -10.7,
    y2: 204.7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#satisfaction_survey_svg2__a",
    id: "satisfaction_survey_svg2__r",
    x1: 253,
    x2: 63.2,
    y1: -9.9,
    y2: 205.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M161.3 200H38.7c-8.1 0-14.6-6.6-14.6-14.6V20.6C24.1 12.5 30.7 6 38.7 6h25.1c1.6 0 2.9 1.3 2.9 2.9s-1.3 2.9-2.9 2.9H38.7c-4.8 0-8.7 3.9-8.7 8.7v164.8c0 4.8 3.9 8.7 8.7 8.7h122.5c4.8 0 8.7-3.9 8.7-8.7V20.6c0-4.8-3.9-8.7-8.7-8.7h-13.4c-1.6 0-2.9-1.3-2.9-2.9s1.3-2.9 2.9-2.9h13.4c8.1 0 14.6 6.6 14.6 14.6v164.8c0 8.1-6.6 14.6-14.6 14.6Z",
    style: {
      strokeWidth: 0,
      fill: "url(#satisfaction_survey_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7 146.1c-1.6 0-2.9-1.3-2.9-2.9V22.6c0-2.7 2.2-4.9 4.9-4.9h23.2c1.6 0 2.9 1.3 2.9 2.9s-1.3 2.9-2.9 2.9H41.7v119.7c0 1.6-1.3 2.9-2.9 2.9Z",
    style: {
      strokeWidth: 0,
      fill: "url(#satisfaction_survey_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.5 187.7H40.7c-2.7 0-4.9-2.2-4.9-4.9v-27.9c0-1.6 1.3-2.9 2.9-2.9s2.9 1.3 2.9 2.9v26.9h88.6l28.1-28.1V23.5h-22.2c-1.6 0-2.9-1.3-2.9-2.9s1.3-2.9 2.9-2.9h23.2c2.7 0 4.9 2.2 4.9 4.9V155q0 1.2-.9 2.1l-29.8 29.8c-.5.5-1.3.9-2.1.9Zm27.8-164.2",
    style: {
      strokeWidth: 0,
      fill: "url(#satisfaction_survey_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.5 187.7c-.4 0-.8 0-1.1-.2-1.1-.5-1.8-1.5-1.8-2.7v-18.1c0-8.1 6.5-14.6 14.6-14.6h18.1c1.2 0 2.3.7 2.7 1.8s.2 2.4-.6 3.2l-29.8 29.8q-.9.9-2.1.9Zm11.6-29.8c-4.8 0-8.7 3.9-8.7 8.7v11.1l19.8-19.8z",
    style: {
      strokeWidth: 0,
      fill: "url(#satisfaction_survey_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.2 43.3H63.8c-4.8 0-8.8-3.9-8.8-8.8v-8.1c0-4.8 3.9-8.8 8.8-8.8s2.9 1.3 2.9 2.9-1.3 2.9-2.9 2.9-2.9 1.3-2.9 2.9v8.1c0 1.6 1.3 2.9 2.9 2.9h72.3c1.6 0 2.9-1.3 2.9-2.9v-8.1c0-1.6-1.3-2.9-2.9-2.9s-2.9-1.3-2.9-2.9 1.3-2.9 2.9-2.9c4.8 0 8.8 3.9 8.8 8.8v8.1c0 4.8-3.9 8.8-8.8 8.8Z",
    style: {
      strokeWidth: 0,
      fill: "url(#satisfaction_survey_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.5 29.9H70.4c-5.3 0-9.6-4.3-9.6-9.6V9.5c0-5.3 4.3-9.6 9.6-9.6h59.1c5.3 0 9.6 4.3 9.6 9.6v10.8c0 5.3-4.3 9.6-9.6 9.6m-59-24c-2 0-3.7 1.7-3.7 3.7v10.8c0 2 1.7 3.7 3.7 3.7h59.1c2 0 3.7-1.7 3.7-3.7V9.6c0-2-1.7-3.7-3.7-3.7z",
    style: {
      strokeWidth: 0,
      fill: "url(#satisfaction_survey_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 89.7H61.9c-3.6 0-6.4-2.9-6.4-6.4V62.2c0-3.6 2.9-6.4 6.4-6.4h9.5c1.6 0 2.9 1.3 2.9 2.9s-1.3 2.9-2.9 2.9h-9.5c-.3 0-.6.3-.6.6v21.1c0 .3.3.6.6.6H83c.3 0 .6-.3.6-.6v-7.4c0-1.6 1.3-2.9 2.9-2.9s2.9 1.3 2.9 2.9v7.4c0 3.6-2.9 6.4-6.4 6.4",
    style: {
      strokeWidth: 0,
      fill: "url(#satisfaction_survey_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3 76c-1.7 0-3.3-.7-4.6-1.9L65.6 70c-1.1-1.1-1.1-3 0-4.1s3-1.1 4.1 0l4.1 4.1c.1.1.3.2.4.2s.3 0 .4-.2l11-11c1.1-1.1 3-1.2 4.1 0 1.1 1.1 1.2 3 0 4.1l-11 11a6.42 6.42 0 0 1-4.6 1.9Z",
    style: {
      strokeWidth: 0,
      fill: "url(#satisfaction_survey_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.6 61.5H99.8c-1.6 0-2.9-1.3-2.9-2.9s1.3-2.9 2.9-2.9h41.8c1.6 0 2.9 1.3 2.9 2.9s-1.3 2.9-2.9 2.9",
    style: {
      strokeWidth: 0,
      fill: "url(#satisfaction_survey_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.6 73.3H99.8c-1.6 0-2.9-1.3-2.9-2.9s1.3-2.9 2.9-2.9h41.8c1.6 0 2.9 1.3 2.9 2.9s-1.3 2.9-2.9 2.9",
    style: {
      strokeWidth: 0,
      fill: "url(#satisfaction_survey_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 129.6H61.9c-3.6 0-6.4-2.9-6.4-6.4v-21.1c0-3.6 2.9-6.4 6.4-6.4h9.5c1.6 0 2.9 1.3 2.9 2.9s-1.3 2.9-2.9 2.9h-9.5c-.3 0-.6.3-.6.6v21.1c0 .3.3.6.6.6H83c.3 0 .6-.3.6-.6v-7.4c0-1.6 1.3-2.9 2.9-2.9s2.9 1.3 2.9 2.9v7.4c0 3.6-2.9 6.4-6.4 6.4",
    style: {
      strokeWidth: 0,
      fill: "url(#satisfaction_survey_svg2__k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3 115.9c-1.7 0-3.3-.7-4.6-1.9l-4.1-4.1c-1.1-1.1-1.1-3 0-4.1s3-1.1 4.1 0l4.1 4.1c.1.1.3.2.4.2s.3 0 .4-.2l11-11c1.1-1.1 3-1.2 4.1 0 1.1 1.1 1.2 3 0 4.1l-11 11a6.42 6.42 0 0 1-4.6 1.9Z",
    style: {
      fill: "url(#satisfaction_survey_svg2__l)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.6 101.4H99.8c-1.6 0-2.9-1.3-2.9-2.9s1.3-2.9 2.9-2.9h41.8c1.6 0 2.9 1.3 2.9 2.9s-1.3 2.9-2.9 2.9",
    style: {
      strokeWidth: 0,
      fill: "url(#satisfaction_survey_svg2__m)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.1 113.1H99.9c-1.6 0-2.9-1.3-2.9-2.9s1.3-2.9 2.9-2.9h24.2c1.6 0 2.9 1.3 2.9 2.9s-1.3 2.9-2.9 2.9",
    style: {
      strokeWidth: 0,
      fill: "url(#satisfaction_survey_svg2__n)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 169.5H61.9c-3.6 0-6.4-2.9-6.4-6.4V142c0-3.6 2.9-6.4 6.4-6.4h9.5c1.6 0 2.9 1.3 2.9 2.9s-1.3 2.9-2.9 2.9h-9.5c-.3 0-.6.3-.6.6v21.1c0 .3.3.6.6.6H83c.3 0 .6-.3.6-.6v-7.4c0-1.6 1.3-2.9 2.9-2.9s2.9 1.3 2.9 2.9v7.4c0 3.6-2.9 6.4-6.4 6.4",
    style: {
      strokeWidth: 0,
      fill: "url(#satisfaction_survey_svg2__o)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3 155.8c-1.7 0-3.3-.7-4.6-1.9l-4.1-4.1c-1.1-1.1-1.1-3 0-4.1s3-1.1 4.1 0l4.1 4.1c.1.1.3.2.4.2s.3 0 .4-.2l11-11c1.1-1.1 3-1.2 4.1 0 1.1 1.1 1.2 3 0 4.1l-11 11a6.42 6.42 0 0 1-4.6 1.9Z",
    style: {
      strokeWidth: 0,
      fill: "url(#satisfaction_survey_svg2__p)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.6 141.3H99.8c-1.6 0-2.9-1.3-2.9-2.9s1.3-2.9 2.9-2.9h41.8c1.6 0 2.9 1.3 2.9 2.9s-1.3 2.9-2.9 2.9",
    style: {
      strokeWidth: 0,
      fill: "url(#satisfaction_survey_svg2__q)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.1 153H99.9c-1.6 0-2.9-1.3-2.9-2.9s1.3-2.9 2.9-2.9h24.2c1.6 0 2.9 1.3 2.9 2.9s-1.3 2.9-2.9 2.9",
    style: {
      strokeWidth: 0,
      fill: "url(#satisfaction_survey_svg2__r)"
    }
  }));
};
export default SvgSatisfactionSurvey;